import React from 'react';
import Header from './Header';
import { Helmet } from 'react-helmet';

function Homepage() {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "School",
    "name": "Sahaj Public School",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Shajapur",
      "addressLocality": "Shajapur",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "465001",
      "addressCountry": "IN"
    },
    "telephone": "+917000434300",
    "email": "sahajpublic01@gmail.com",
    "url": "https://sahajpublicschool.org",
    "description": "Sahaj Public School offers quality education from Nursery to 12th standard with experienced teachers and excellent infrastructure in Shajapur, Madhya Pradesh.",
    "founder": {
      "@type": "Person",
      "name": "Govind Verma"
    },
    "sameAs": [
      "https://www.facebook.com/sahajpublicschool",
      "https://twitter.com/sahajpublic",
      "https://instagram.com/sahajpublicschool"
    ]
  };

  return (
    <div>
      <Helmet>
        <title>Sahaj Public School, Shajapur | Top School in Madhya Pradesh</title>
        <meta name="description" content="Enroll your child at Sahaj Public School in Shajapur, M.P. We provide excellent education from Nursery to 12th, modern facilities, and experienced staff." />
        <meta name="keywords" content="Sahaj Public School, school in Shajapur, best school in Shajapur, Nursery to 12th, Madhya Pradesh schools, quality education Shajapur" />
        <meta name="author" content="Sahaj Public School" />
        <meta property="og:title" content="Sahaj Public School | Quality Education in Shajapur, M.P." />
        <meta property="og:description" content="Best school in Shajapur offering Nursery to 12th standard education with focus on academic and holistic development." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sahajpublicschool.org" />
        <meta property="og:image" content="https://sahajpublicschool.org/og-image.jpg" /> {/* Change this URL to your actual image */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sahaj Public School, Shajapur | Top School in M.P." />
        <meta name="twitter:description" content="Join Sahaj Public School for quality education from Nursery to 12th in Shajapur, Madhya Pradesh." />
        <meta name="twitter:image" content="https://sahajpublicschool.org/twitter-image.jpg" /> {/* Change this URL */}
        {/* JSON-LD structured data */}
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>

      <Header />

    </div>
  );
}

export default Homepage;
